import { useEffect, useState } from "react"
import { toast } from "sonner"

import { Dropdown } from "../Dropdown"
import { getCategoriesAction } from "@/actions/realstate/realstate.action"
import { Category, FieldProps } from "@/app/types"

interface Props extends FieldProps {
  value: Category | { id: ""; name: "All" }
  onChange: (value: Category | null) => void
}

export const PropertyTypeField = ({ value, onChange, className, label }: Props & { label?: string }) => {
  const [categories, setCategories] = useState<Category[]>([])

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response: any = await getCategoriesAction()
        setCategories([{ id: "", name: "All" }, ...response.data.data])
      } catch (error) {
        toast.error("Failed to load categories.")
      }
    }
    fetchCategories()
  }, [])

  return (
    <Dropdown className={className} items={categories} label={label || "I'm looking to..."} value={value} onChange={onChange} />
  )
}
